<ng-container screenAnalytics="site-location-edit">
    <div class="modal-header">
        <div class="panel-heading-icon">
            <img imgPath="/icons/icon-locations.png" />
        </div>
        <h3 class="modal-title">Edit Site Areas</h3>
        <enhanced-help-switch></enhanced-help-switch>
        <knowledge-base-link></knowledge-base-link>
        <button
            type="button"
            (click)="close()"
            aria-label="Close"
            class="close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body horizontal-container max-height no-padding">
        <location-edit-drawing
            #drawingComponent
            [featureGroups]="featureGroups"
            [organisationId]="organisationId"
            [workTracker]="workTracker"
            [mapData$]="mapData$"
            [airspaceValue$]="airspaceValue$"
            [requiredFeatureTypes]="[]"
            [showSiteBoundaries]="false"
            [showNotices]="false"
            [showExternalMissions]="false"
            (featureGroupsChange)="onFeatureGroupsChange($event)"
            (isAddingFeatureChange)="onIsAddingFeatureChange($event)"
            (hasAnyFeaturesChange)="onHasAnyFeaturesChange($event)"
        ></location-edit-drawing>
    </div>
    <div class="modal-footer">
        <button
            [disabled]="!hasAnyFeatures"
            class="btn btn-link"
            type="button"
            (click)="downloadKml()"
            analyticsOn
            analyticsAction="download-kml"
        >
            Download KML
        </button>
        <button
            type="button"
            class="btn btn-default"
            ngfSelect
            multiple="false"
            accept="application/vnd.google-earth.kml\+xml,application/vnd.google-earth.kmz,application/zip,.kml,.kmz,application/x-zip-compressed,application/json,.json"
            (fileChange)="uploadLocation($event)"
            placement="top"
            tooltip="Upload KML or KMZ files"
            enhancedHelp="upload-geometry"
        >
            Upload Geometry
        </button>
        <button type="button" class="btn btn-default" (click)="close()">
            Cancel
        </button>
        <button
            class="btn btn-primary"
            type="button"
            (click)="save()"
            [disabled]="isAddingFeature"
            [tooltip]="
                isAddingFeature
                    ? 'Please finish adding the current map feature before saving'
                    : undefined
            "
            placement="top"
        >
            Save
        </button>
    </div>
</ng-container>
